// extracted by mini-css-extract-plugin
export default {"Emojify":"bbo_a bho_g"};